var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgExcelType = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 16,
    fill: "#E9F9EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 33.5286V75.8778C72 78.1582 70.093 80 67.7319 80H28.2681C25.907 80 24 78.1582 24 75.8778V20.1222C24 17.8418 25.907 16 28.2681 16H53.8508L72 33.5286Z",
    fill: "#23A566"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6091 48H37.3778C36.6167 48 36 48.5806 36 49.2971V66.7029C36 67.4194 36.6167 68 37.3778 68H58.6222C59.3833 68 60 67.4194 60 66.7029V49.3095C59.9869 48.593 59.3701 48 58.6091 48ZM38.7556 56.3508H46.6156V59.6492H38.7556V56.3508ZM49.3712 56.3508H57.2313V59.6492H49.3712V56.3508ZM57.2313 53.7566H49.3712V50.6065H57.2313V53.7566ZM46.6156 50.6065V53.7566H38.7556V50.6065H46.6156ZM38.7556 62.2557H46.6156V65.4058H38.7556V62.2557ZM49.3712 65.4058V62.2557H57.2313V65.4058H49.3712Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M56 32.6227L72 46V33.4409L62.9232 28L56 32.6227Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72 34H58.233C55.8914 34 54 32.1086 54 29.767V16L72 34Z",
    fill: "#8ED1B1"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgExcelType);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/excel_type.79c31fd393110e4027bcc0d46f573dc7.svg";